import { TextField } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

export default function LocalDatePicker({ state, setState, ...props }) {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        renderInput={(inputProps) => <TextField {...inputProps} variant="outlined"></TextField>}
        localeText={{ start: 'Check-in', end: 'Check-out' }}
        value={state}
        onChange={(e) => setState(e.set({ hour: 0, minute: 0 }))}
        onClose={props?.updateFunction||(()=>{})}
      />
    </LocalizationProvider>
  );
}
